































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Form } from "element-ui";
import {
  addEviMembercertinfo,
  updateEviMembercertinfo,
  deleteEviMembercertinfo,
  getEviMembercertinfoPageList,
  defaultEviMembercertinfoData,
  privateSecretValid,
  certificationPayCode,
  certApply
} from "@/api/evimembercertinfo";
import { IEviMembercertinfo } from "@/model/evimembercertinfo";
import Pagination from "@/components/Pagination/index.vue";
import { sMSAuthenticationCode } from "@/api/common";
import {
  certinfoUserTypeDic,
  certinfoTypeDic,
  certinfoBuyTypeDic,
  certinfoIssueTypeDic
} from "@/enum/index";
import { openLoading, closeLoading } from "@/utils/loading";

@Component({
  name: "eviMembercertinfo",
  components: {
    Pagination
  },
  filters: {
    certinfoUserTypeFilter: (key: number) => {
      return certinfoUserTypeDic.find((o: any) => o.key === key)?.value;
    },
    certinfoTypeFilter: (key: number) => {
      return certinfoTypeDic.find((o: any) => o.key === key)?.value;
    },
    certinfoBuyTypeFilter: (key: number) => {
      return certinfoBuyTypeDic.find((o: any) => o.key === key)?.value;
    },
    certinfoIssueTypeFilter: (key: number) => {
      return certinfoIssueTypeDic.find((o: any) => o.key === key)?.value;
    }
  }
})
export default class extends Vue {
  private tableKey = 0;
  private eviMembercertinfoData = defaultEviMembercertinfoData;
  private list: IEviMembercertinfo[] = [];
  private total = 0;
  private listLoading = false;
  private listQuery = {
    pageIndex: 1,
    pageSize: 20,
    search: ""
  };

  private loading = false;

  private certinfoUserTypeDic = certinfoUserTypeDic;
  private certinfoTypeDic = certinfoTypeDic;
  private certinfoBuyTypeDic = certinfoBuyTypeDic;
  private certinfoIssueTypeDic = certinfoIssueTypeDic;

  private dialogCreateVisible = false;
  private dialogSecretVisible = false;
  private dialogPrivateSecretVisible = false;

  private privateSecretShow = false;

  // 验证码发送后，60秒倒计时后才可再点击
  private validCodeDisabled = false;
  private time = 0;
  private btntxt = "重新发送";

  private validCodeInput = {
    phone: "",
    authenticationType: 2
  };

  private privateSecretValidInput = {
    phone: "",
    validCode: ""
  };

  private createRules = {
    memberId: [{ required: true, message: "用户id必填", trigger: "blur" }],

    memberType: [
      {
        type: "number",
        min: 0,
        required: true,
        message: "用户类别必填",
        trigger: "change"
      }
    ],

    certType: [
      {
        type: "number",
        min: 0,
        required: true,
        message: "证书类别必填",
        trigger: "change"
      }
    ],

    certUserName: [
      { required: true, message: "证书使用名必填", trigger: "blur" }
    ],

    certUserAdditionalField: [
      {
        required: true,
        message: "证书附加属性必填",
        trigger: "blur"
      }
    ],

    certPasswd: [{ required: true, message: "证书密码必填", trigger: "blur" }],

    orderId: [{ required: true, message: "订单Id必填", trigger: "blur" }]
  };

  private privateSecretRules = {
    phone: [{ required: true, message: "手机号必填", trigger: "blur" }],
    validCode: [{ required: true, message: "验证码必填", trigger: "blur" }]
  };

  private getCertPayCode() {
    (this.$refs.createForm as Form).validate(async (valid: boolean) => {
      if (valid) {
        openLoading();
        await certApply(this.eviMembercertinfoData).then((res: any) => {
          this.dialogCreateVisible = false;
          this.eviMembercertinfoData.accountAddress = res.data.accountAddress;
          this.eviMembercertinfoData.accountPublicKey =
            res.data.accountPublicKey;
          this.eviMembercertinfoData.accountPrivateKey =
            res.data.accountPrivateKey;
          this.privateSecretShow = true;
          this.dialogSecretVisible = true;
          this.getList();

          this.$message({
            message: "证书申请成功！",
            type: "success"
          });
          closeLoading();
        }).catch(() => {
          closeLoading();
          return false;
        });
      } else {
        return false;
      }
    });
  }

  // 60S倒计时
  private timer() {
    if (this.time > 0) {
      this.time--;
      this.btntxt = this.time + "s后重新获取";
      setTimeout(this.timer, 1000);
    } else {
      this.time = 0;
      this.btntxt = "获取验证码";
      this.validCodeDisabled = false;
    }
  }

  private privateSecretSubmit() {
    (this.$refs.privateSecretForm as Form).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await privateSecretValid(this.privateSecretValidInput)
          .then(() => {
            this.$message({
              message: "验证成功！",
              type: "success"
            });

            this.privateSecretShow = true;
            this.dialogPrivateSecretVisible = false;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            return false;
          });
      } else {
        return false;
      }
    });
  }

  // 手机验证发送验证码
  private sendcode() {
    const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
    if (this.privateSecretValidInput.phone === "") {
      this.$message({
        message: "手机号不能为空",
        center: true
      });
      return;
    }
    if (!reg.test(this.privateSecretValidInput.phone)) {
      this.$message({
        message: "请输入正确的手机号",
        center: true
      });
    } else {
      this.validCodeInput.phone = this.privateSecretValidInput.phone;
      sMSAuthenticationCode(this.validCodeInput).then(() => {
        this.$message({
          message: "发送成功",
          type: "success",
          center: true
        });
      });

      this.time = 60;
      this.validCodeDisabled = true;
      this.timer();
    }
  }

  private getPrivarySecretDialog() {
    this.privateSecretValidInput.phone = "";
    this.privateSecretValidInput.validCode = "";
    this.dialogPrivateSecretVisible = true;
  }

  private openSecretDialog(info: IEviMembercertinfo) {
    this.setData(info);
    this.dialogSecretVisible = true;
    this.privateSecretShow = false;
  }

  private openCreateDialog() {
    this.initData();
    this.dialogCreateVisible = true;
  }

  private closeCreateDialog() {
    (this.$refs.createForm as Form).resetFields();
    this.dialogCreateVisible = false;
  }

  private handleFilter() {
    this.listQuery.pageIndex = 1;
    this.getList();
  }

  created() {
    this.getList();
  }

  private handleUpdate(data: IEviMembercertinfo) {
    this.dialogCreateVisible = true;
    // this.eviAppData = data;
    this.setData(data);
  }

  private initData() {
    this.eviMembercertinfoData.id = "";
    this.eviMembercertinfoData.memberId = "";
    this.eviMembercertinfoData.memberType = -1;
    this.eviMembercertinfoData.certType = -1;
    this.eviMembercertinfoData.certUserName = "";
    this.eviMembercertinfoData.certUserAdditionalField = "";
    this.eviMembercertinfoData.certIssueTime = 0;
    this.eviMembercertinfoData.certExpireTime = 0;
    this.eviMembercertinfoData.certOrg = "";
    this.eviMembercertinfoData.certSignatureAlgorithm = "";
    this.eviMembercertinfoData.certSerialNumber = "";
    this.eviMembercertinfoData.certSignBuf = "";
    this.eviMembercertinfoData.accountAddress = "";
    this.eviMembercertinfoData.accountPublicKey = "";
    this.eviMembercertinfoData.accountPrivateKey = "";
    this.eviMembercertinfoData.createTime = 0;
    this.eviMembercertinfoData.updateTime = 0;
    this.eviMembercertinfoData.certStatus = 0;
    this.eviMembercertinfoData.signStatus = 0;
    this.eviMembercertinfoData.certUrl = "";
    this.eviMembercertinfoData.certPasswd = "";
    this.eviMembercertinfoData.orderId = "";
  }

  private setData(data: IEviMembercertinfo) {
    this.eviMembercertinfoData.id = data.id;
    this.eviMembercertinfoData.memberId = data.memberId;
    this.eviMembercertinfoData.memberType = data.memberType;
    this.eviMembercertinfoData.certType = data.certType;
    this.eviMembercertinfoData.certUserName = data.certUserName;
    this.eviMembercertinfoData.certUserAdditionalField =
      data.certUserAdditionalField;
    this.eviMembercertinfoData.certIssueTime = data.certIssueTime;
    this.eviMembercertinfoData.certExpireTime = data.certExpireTime;
    this.eviMembercertinfoData.certOrg = data.certOrg;
    this.eviMembercertinfoData.certSignatureAlgorithm =
      data.certSignatureAlgorithm;
    this.eviMembercertinfoData.certSerialNumber = data.certSerialNumber;
    this.eviMembercertinfoData.certSignBuf = data.certSignBuf;
    this.eviMembercertinfoData.accountAddress = data.accountAddress;
    this.eviMembercertinfoData.accountPublicKey = data.accountPublicKey;
    this.eviMembercertinfoData.accountPrivateKey = data.accountPrivateKey;
    this.eviMembercertinfoData.createTime = data.createTime;
    this.eviMembercertinfoData.updateTime = data.updateTime;
    this.eviMembercertinfoData.certStatus = data.certStatus;
    this.eviMembercertinfoData.signStatus = data.signStatus;
    this.eviMembercertinfoData.certUrl = data.certUrl;
    this.eviMembercertinfoData.certPasswd = data.certPasswd;
    this.eviMembercertinfoData.orderId = data.orderId;
  }

  private deleteEviMembercertinfo(id: string) {
    this.$confirm("此操作将永久删除, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        await deleteEviMembercertinfo(id).then(() => {
          this.getList();

          this.$message({
            type: "success",
            message: "删除成功!"
          });
        });
      });
    // .catch(() => {
    //   this.$message({
    //     type: "info",
    //     message: "已取消删除"
    //   });
    // });
  }

  private async update() {
    (this.$refs.createForm as Form).validate(async valid => {
      if (valid) {
        await updateEviMembercertinfo(this.eviMembercertinfoData);

        this.$message({
          message: "修改成功",
          type: "success",
          duration: 2000
        });

        this.initData();
        this.dialogCreateVisible = false;
        this.getList();
      }
    });
  }

  private async create() {
    (this.$refs.createForm as Form).validate(async valid => {
      if (valid) {
        await addEviMembercertinfo(this.eviMembercertinfoData).then(() => {
          this.$message({
            message: "创建成功",
            type: "success",
            duration: 2000
          });

          this.initData();
          this.dialogCreateVisible = false;
          this.getList();
        });
      }
    });
  }

  // 获取列表数据
  private async getList() {
    this.listLoading = true;
    const { data } = await getEviMembercertinfoPageList(this.listQuery);
    this.list = data.list;
    this.total = data.total;
    // Just to simulate the time of the request
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }
}
